var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan0, _tspan1, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg38959",
    viewBox: "0 0 793.43 625.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(161.45 -198.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g96187",
    style: {
      stroke: "#000000",
      strokeWidth: 4
    },
    transform: "matrix(1.0055 0 0 1.0055 288.6 905.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96179",
    style: {
      stroke: "#000000",
      strokeWidth: 4,
      fill: "#784421"
    },
    d: "m-328.88-399.33-116.7 159.14s122.01 31.828 392.54 33.596c270.53-1.7682 392.54-33.596 392.54-33.596l-116.71-159.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96184",
    style: {
      stroke: "#000000",
      strokeWidth: 4,
      fill: "#502d16"
    },
    d: "m339.49-213.67s-122.01 31.828-392.54 33.596c-270.53-1.7682-392.54-33.596-392.54-33.596l0.8841-28.291s121.12 33.596 391.66 35.364c270.53-1.7682 390.77-35.364 390.77-35.364z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96103",
    transform: "matrix(1.0055 0 0 1.0055 308.16 805.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g95142",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g95131",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect95125",
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      fill: "#000000"
    },
    rx: 21.552,
    ry: 19.821,
    height: 35.009,
    width: 226.31,
    y: -514.27,
    x: -173.79
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect95127",
    ry: 17.504,
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      fill: "#000000"
    },
    rx: 21.552,
    transform: "rotate(-90)",
    height: 35.009,
    width: 342.14,
    y: -194.42,
    x: 260.28
  })), /*#__PURE__*/React.createElement("g", {
    id: "g95136",
    style: {
      fill: "#000000"
    },
    transform: "matrix(-1 0 0 1 -141.91 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect95140",
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      fill: "#000000"
    },
    transform: "rotate(-90)",
    rx: 21.552,
    ry: 16.319,
    height: 35.009,
    width: 336.33,
    y: -194.42,
    x: 266.08
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g96089",
    transform: "translate(12.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect96012",
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      fill: "#666666"
    },
    d: "m65.031-428.16c-13.743-0.45773-24.377 13.981-21.758 27.094-0.07899 32.655-0.71964 65.398 0.38281 98 3.3989 17.409 19.142 30.697 36.502 33.223 40.707 12.569 81.262 25.886 122.31 37.183 13.329 1.0341 26.14-11.532 23.823-25.094 0.13009-33.631 0.90408-67.373-0.47895-100.94-3.7088-17.2-19.582-30.121-36.737-32.731-40.163-12.083-80.047-25.346-120.39-36.676-1.217-0.0701-2.4375-0.13205-3.6562-0.0625z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect95062",
    ry: 21.489,
    style: {
      stroke: "#000000",
      strokeWidth: 3.0689,
      fill: "#000000"
    },
    rx: 22.488,
    transform: "matrix(-.95560 -.29468 0 1 0 0)",
    height: 138.78,
    width: 175.33,
    y: -441.46,
    x: -228.74
  }), /*#__PURE__*/React.createElement("text", {
    id: "text95496",
    style: {
      strokeWidth: 1.482,
      letterSpacing: 0,
      fontWeight: 500,
      fontSize: "8.5439px",
      wordSpacing: 0,
      stroke: "#50ff50",
      fontFamily: "TlwgMono",
      lineHeight: "125%",
      fill: "#50ff50"
    },
    transform: "matrix(.85439 .27244 0 1.1704 0 0)",
    y: -361.95145,
    x: 70.253899,
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95618",
    y: -361.95145,
    x: 70.253899
  }, "void groups_free(struct=) {")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95622",
    y: -351.27155,
    x: 70.253899
  }, "    if (group_info-&gt;blocks[0]) {")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95626",
    y: -340.59161,
    x: 70.253899
  }, "        int i;")), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95630",
    y: -329.91171,
    x: 70.253899
  }, "        for (i = 0; i &lt; 1; i++)")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95634",
    y: -319.23178,
    x: 70.253899
  }, "            free_page();")), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95638",
    y: -308.55188,
    x: 70.253899
  }, "    }")), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95640",
    y: -297.87198,
    x: 70.253899
  }, "    kfree(group_info);")), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95642",
    y: -287.19205,
    x: 70.253899
  })), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95644",
    y: -276.51215,
    x: 70.253899
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g96056",
    transform: "translate(-13.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect96010",
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      fill: "#666666"
    },
    d: "m-194.09-428.22c-17.443 2.7642-33.671 10.426-50.756 14.775-29.773 9.465-60.19 17.358-89.338 28.506-15.024 8.7982-22.39 27.356-19.634 44.312 0.61845 31.152-1.7552 62.529 1.3531 93.531 4.5416 13.431 22.253 17.752 34.109 11.726 42.493-14.121 86.077-25.226 128.05-40.695 15.193-8.7386 22.423-27.45 19.697-44.437-0.60029-31.059 1.6613-62.333-1.3215-93.25-2.9734-9.1299-12.776-14.939-22.156-14.469z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect95060",
    style: {
      stroke: "#000000",
      strokeWidth: 3.0689,
      fill: "#000000"
    },
    transform: "matrix(.95560 -.29468 0 1 0 0)",
    rx: 22.488,
    ry: 21.489,
    height: 138.78,
    width: 175.33,
    y: -480.75,
    x: -362.07
  }), /*#__PURE__*/React.createElement("text", {
    id: "text95149-4",
    style: {
      strokeWidth: 1.482,
      letterSpacing: 0,
      fontWeight: 500,
      fontSize: "8.697px",
      wordSpacing: 0,
      stroke: "#50ff50",
      fontFamily: "TlwgMono",
      lineHeight: "125%",
      fill: "#50ff50"
    },
    xmlSpace: "preserve",
    transform: "matrix(.87538 -.28316 0 1.1424 0 0)",
    y: -410.93234,
    x: -401.90527
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95426",
    x: -401.90527,
    y: -410.93234
  }, "    if (gidsetsize &lt;= NGROUPS_SMALL)")), _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95430",
    x: -401.90527,
    y: -400.06104
  }, "        group_info-&gt;blocks[0] = gr;")), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95434",
    x: -401.90527,
    y: -389.18976
  }, "    else {")), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95438",
    x: -401.90527,
    y: -378.31845
  }, "        for (i = 0; i &lt; nb; i++) {")), _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95442",
    x: -401.90527,
    y: -367.44717
  }, "            gid_t *b;")), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95446",
    x: -401.90527,
    y: -356.57587
  }, "            b = (void *)__get(GFP);")), _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95450",
    x: -401.90527,
    y: -345.70456
  }, "            if (!b)")), _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95454",
    x: -401.90527,
    y: -334.83328
  }, "                goto partial_alloc;")), _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95458",
    x: -401.90527,
    y: -323.96198
  }, "            group_info-&gt;blo[i] = b;")), _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95468",
    x: -401.90527,
    y: -313.0907
  }, "        }")))), /*#__PURE__*/React.createElement("g", {
    id: "g96071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect96008",
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      fill: "#666666"
    },
    d: "m24.281-432.44c-61.707 0.86254-123.58-0.78682-185.19 0.875-16.083 3.4715-25.749 21.501-22.671 37.219 0.6613 32.084-1.6136 64.34 1.2965 96.313 4.4805 15.538 22.462 23.395 37.656 20.557 59.75-0.53716 119.59 1.2101 179.28-0.96307 15.601-4.0528 24.383-21.692 21.515-37-0.8058-32.369 1.887-64.972-1.5465-97.188-4.3231-12.305-17.349-20.584-30.344-19.812z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect95058",
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      fill: "#000000"
    },
    rx: 21.489,
    ry: 21.489,
    height: 138.78,
    width: 223.8,
    y: -424.25,
    x: -175.61
  }), /*#__PURE__*/React.createElement("text", {
    id: "text95149",
    style: {
      strokeWidth: 1.482,
      letterSpacing: 0,
      fontWeight: 500,
      fontSize: 10,
      wordSpacing: 0,
      stroke: "#50ff50",
      fontFamily: "TlwgMono",
      lineHeight: "125%",
      fill: "#50ff50"
    },
    xmlSpace: "preserve",
    y: -408.91638,
    x: -168.07318
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95159",
    x: -168.07318,
    y: -408.91638
  }, "struct group_info *group_info;")), _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95163",
    x: -168.07318,
    y: -396.41638
  }, "int nblocks;")), _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95167",
    x: -168.07318,
    y: -383.91638
  }, "int i;")), _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95175",
    x: -168.07318,
    y: -371.41638
  }, "nblocks = (gidsetsize + 1")), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95179",
    x: -168.07318,
    y: -358.91638
  }, "/* Allocate one indirect pointer */")), _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95183",
    x: -168.07318,
    y: -346.41638
  }, "inblocks = nblocks ? : 1;")), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95216",
    x: -168.07318,
    y: -333.91638
  }, "group_info = kmalloc(sizeof(*g))")), _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95220",
    x: -168.07318,
    y: -321.41638
  }, "if (!group_info)")), _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95224",
    x: -168.07318,
    y: -308.91638
  }, "    return NULL;")), _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95230",
    x: -168.07318,
    y: -296.41638
  }, "group_info-&gt;ngroups = gidsetsize;")), _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95232",
    x: -168.07318,
    y: -283.91638
  })), _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95234",
    x: -168.07318,
    y: -271.41638
  })), _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95187",
    x: -168.07318,
    y: -258.91638
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g95089",
    style: {
      fill: "#000000"
    },
    transform: "translate(64.452 32.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect95988",
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      fill: "#666666"
    },
    d: "m-164.19-620.09c-51.99 4.9631-104.28 7.1088-156.16 12.938-16.25 4.8914-25.065 23.444-22.052 39.594 0.69439 31.918-1.8121 64.096 1.4579 95.844 4.853 14.525 22.47 21.217 36.653 17.447 49.836-4.4239 99.969-6.3553 149.6-12.572 15.415-5.4374 23.573-23.345 20.739-38.969-0.69182-31.828 1.7314-63.885-1.3641-95.563-3.786-11.915-16.617-19.633-28.875-18.719z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect95058-9",
    style: {
      stroke: "#000000",
      strokeWidth: 3.0044,
      fill: "#000000"
    },
    transform: "matrix(.99707 -.076502 0 1 0 0)",
    rx: 21.552,
    ry: 21.489,
    height: 138.78,
    width: 193.11,
    y: -624.44,
    x: -335.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect95998",
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      fill: "#666666"
    },
    d: "m-97.594-619.97c-15.342 1.2791-27.525 17.066-24.663 32.344 0.007 32.54-0.83973 65.169 0.444 97.656 3.4428 15.967 19.931 27.031 36.087 25.229 49.292 3.947 98.656 8.2499 147.98 11.052 14.949-1.8714 26.451-17.195 23.725-32.125-0.02039-32.829 0.96424-65.851-0.60016-98.563-3.9043-15.772-20.414-26.265-36.31-24.64-48.884-3.6296-97.748-7.9311-146.66-10.954z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect95087",
    ry: 21.489,
    style: {
      stroke: "#000000",
      strokeWidth: 3.0044,
      fill: "#000000"
    },
    rx: 21.552,
    transform: "matrix(-.99707 -.076502 0 1 0 0)",
    height: 138.78,
    width: 193.11,
    y: -604.78,
    x: -78.374
  })), /*#__PURE__*/React.createElement("text", {
    id: "text95662",
    style: {
      strokeWidth: 1.482,
      letterSpacing: 0,
      fontWeight: 500,
      fontSize: "9.4293px",
      wordSpacing: 0,
      stroke: "#50ff50",
      fontFamily: "TlwgMono",
      lineHeight: "125%",
      fill: "#50ff50"
    },
    xmlSpace: "preserve",
    transform: "matrix(.94293 -.081806 0 1.0605 0 0)",
    y: -530.41217,
    x: -267.3187
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95780",
    x: -267.3187,
    y: -530.41217
  }, "for (i = 0; i &lt; 3; i++) {")), _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95784",
    x: -267.3187,
    y: -518.62555
  }, "    unsigned int cp_count;")), _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95792",
    x: -267.3187,
    y: -506.83893
  }, "    unsigned int len = n;")), _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95796",
    x: -267.3187,
    y: -495.05234
  }, "    if (user(group_info[i]){")), _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95802",
    x: -267.3187,
    y: -483.26572
  }, "        return -EFAULT;")), _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95806",
    x: -267.3187,
    y: -471.4791
  }, "    grouplist += NGS_PER_BLOCK;")), _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95810",
    x: -267.3187,
    y: -459.69247
  }, "    count -= cp_count;")), _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95814",
    x: -267.3187,
    y: -447.90585
  }))), /*#__PURE__*/React.createElement("text", {
    id: "text95838",
    style: {
      strokeWidth: 1.482,
      letterSpacing: 0,
      fontWeight: 500,
      fontSize: "9.5717px",
      wordSpacing: 0,
      stroke: "#50ff50",
      fontFamily: "TlwgMono",
      lineHeight: "125%",
      fill: "#50ff50"
    },
    xmlSpace: "preserve",
    transform: "matrix(.95717 .090815 0 1.0447 0 0)",
    y: -528.22711,
    x: -43.6623
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95864",
    x: -43.6623,
    y: -528.22711
  }, "group_info = kmalloc(usr)")), _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95960",
    x: -43.6623,
    y: -516.26245
  }, "if (!group_info)")), _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95964",
    x: -43.6623,
    y: -504.29779
  }, "    return NULL;")), _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95968",
    x: -43.6623,
    y: -492.33316
  }, "group_info-&gt;ngroups = gidsetsize;")), _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95972",
    x: -43.6623,
    y: -480.3685
  }, "group_info-&gt;nblocks = nblocks;")), _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95976",
    x: -43.6623,
    y: -468.40384
  }, "atomic_set(&amp;group_info-&gt;usage, 1)")))), /*#__PURE__*/React.createElement("path", {
    id: "path97024",
    style: {
      stroke: "#000000",
      strokeWidth: 4.022,
      fill: "#666666"
    },
    d: "m269.12 670.25h166.69l-55.563-69.075h-55.563-166.69-55.563l-55.563 69.075h166.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g97269",
    transform: "matrix(1.0055 0 0 1.0055 302.15 910.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path97229",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeWidth: 4.0617,
      fill: "#e4d3b1"
    },
    d: "m-196.47-252.72c10.718 6.0544 25.741 3.5978 33.555-5.4881 7.8142-9.0859 5.4606-21.359-5.2574-27.415-10.718-6.0549-25.74-3.5976-33.555 5.4878-7.8144 9.0857-5.4606 21.36 5.2572 27.415z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97231",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeWidth: 4,
      fill: "#ff6600"
    },
    d: "m-171.47-274.03c-9.3778-3.1293-21.772 1.6949-28.191 9.2144-19.173 22.463 5.4845 124.02 44.806 108.59 40.539-15.91 21.702-63.063 21.702-63.063s-17.19-47.689-38.317-54.739z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97013",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeWidth: 4,
      fill: "#ff6600"
    },
    d: "m-160.57-297.71c9.3778-3.1293 21.772 1.6949 28.191 9.2144 19.173 22.463 13.958 87.491 13.958 87.491s-19.443 36.53-58.765 21.096c-40.539-15.91-21.702-63.063-21.702-63.063s17.19-47.689 38.317-54.739z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g97264",
    transform: "matrix(1.0055 0 0 1.0055 278.71 912.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path97258",
    d: "m91.754-252.72c-10.718 6.0544-25.741 3.5978-33.555-5.4881-7.8142-9.0859-5.4606-21.359 5.2574-27.415 10.718-6.0549 25.74-3.5976 33.555 5.4878 7.8144 9.0857 5.4606 21.36-5.2572 27.415z",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeWidth: 4.0617,
      fill: "#e4d3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97260",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeWidth: 4,
      fill: "#ff6600"
    },
    d: "m66.758-274.03c9.3778-3.1293 21.772 1.6949 28.191 9.2144 19.173 22.463-5.4845 124.02-44.806 108.59-40.539-15.91-21.702-63.063-21.702-63.063s17.19-47.689 38.317-54.739z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97262",
    d: "m55.856-297.71c-9.3778-3.1293-21.772 1.6949-28.191 9.2144-19.173 22.463-13.958 87.491-13.958 87.491s19.443 36.53 58.765 21.096c40.539-15.91 21.702-63.063 21.702-63.063s-17.19-47.689-38.317-54.739z",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeWidth: 4,
      fill: "#ff6600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path85540",
    d: "m242.46 569.26c-0.39841 0.004-0.80093 0.005-1.1992 0.008-0.22726-0.0102-0.4538-0.0436-0.68049-0.0314-0.35058 0.006-0.70706-0.0325-1.0571-0.026l0.0225 0.0865c-26.766 1.0592-51.577 16.614-68.213 36.468-35.66 42.269-49.301 98.427-50.557 152.49 0.92084 13.884-1.8304 30.495 4.0551 42.609 21.417 13.344 59.207 16.079 84.965 19.502 6.8372 0.4024 17.696 0.64644 29.486 0.88513l-0.002 0.0381c1.2385 0.0306 2.415 0.0216 3.6348 0.0369 0.12131-0.0179 0.24075 0.0111 0.3586-0.007 11.79 0.10793 22.649 0.18091 29.486-0.0206 25.765-2.6668 63.559-4.2932 85.004-17.008 5.9109-11.941 3.1946-28.632 4.1446-42.489-1.14-54.1-14.66-110.66-50.23-153.97-16.6-20.34-41.37-36.63-68.13-38.47l-0.0208-0.12229c-0.35046 0.006-1.0565 0.0182-1.0565 0.0182z",
    style: {
      strokeLinejoin: "round",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeWidth: 4.022,
      fill: "#ff6600"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g97284",
    transform: "matrix(1.0048 .036520 -.036520 1.0048 279.21 898.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect85542",
    style: {
      strokeLinejoin: "bevel",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeWidth: 4,
      fill: "#e4d3b1"
    },
    transform: "matrix(.99209 -.12551 .12551 .99209 0 0)",
    rx: 122.91,
    ry: 106.94,
    height: 221.25,
    width: 256.83,
    y: -487.1,
    x: -133.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85566",
    d: "m-106.77-481.89s43.028-37.308 93.739-37.308 124.47 66.505 124.47 66.505 1.5371 17.843-9.2201 40.552-14.478 15.814-14.478 15.814-14.479 83.153-48.287 97.752c-20.943 9.0436-103.95 7.5174-142.97 2.9467-53.34 1.4357-54.752-12.208-68.744-33.518-23.399-35.638-32.799-98.946-5.7306-127.77 20.776-19.441 64.498-34.256 71.216-24.973z",
    style: {
      stroke: "#000000",
      strokeWidth: 4,
      fill: "#342608"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6d6a6ec8b12d92f5f3cee59201c4335b.svg";
export { ForwardRef as ReactComponent };